package oldframes.segments.static

import bootstrap.*
import ru.it_mozaika.utils.checkResponseError
import oldcomponents.NotyType
import oldcomponents.dropdownSelect
import oldcomponents.page.*
import oldcomponents.pagination
import oldcomponents.showNotification
import web.cssom.ClassName
import io.ktor.client.call.*
import io.ktor.http.*
import js.core.jso
import kotlinx.html.InputType
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLInputElement
import react.dom.*
import react.fc
import react.router.dom.Link
import react.router.useNavigate
import react.router.useParams
import react.useEffect
import react.useEffectOnce
import react.useState
import ru.it_mozaika.components.tablePagination
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.Http
import kotlin.math.min

val staticSegmentFrame = fc<PageContentProps> { props ->
    val navigate = useNavigate()

    val params = useParams()
    val id = params["id"].orEmpty()

    var segment by useState<StaticSegment>()
    var stores by useState(listOf<Store>())
    var name by useState("")
    var store by useState("")
    var lastUpdate by useState("")
    var emails by useState(listOf<String>())
    var filtered by useState(listOf<String>())

    var uploadKey by useState<String>()

    var searchValue by useState("")
    var page by useState(1)
    var rows by useState(30)

    useEffect(searchValue, emails) {
        filtered = if (searchValue.isBlank()) {
            emails
        } else {
            emails.filter { it.contains(searchValue.lowercase()) }
        }
    }

    useEffectOnce {
        Http.get("/stores") { response ->
            response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                navigate("/segments/static")
                return@get
            }
            stores = response.body()
        }
    }

    useEffect(id) {
        Http.get("/segments/static/$id") { response ->
            response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                navigate("/segments/static")
                return@get
            }
            segment = response.body()
        }
    }

    useEffect(segment) {
        segment?.let {
            name = it.name
            store = it.store
            lastUpdate = it.lastUpdate
        }
        Http.get("/segments/static/$id/emails") { response ->
            response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                navigate("/segments/static")
                return@get
            }
            emails = response.body()
        }
    }

    child(pageContent) {
        attrs.headerProps = jso<PageHeaderProps>().apply {
            header = segment?.name ?: "Статический сегмент"
            breadcrumbs = listOf(
                Breadcrumb("/", "", "ti ti-home"),
                Breadcrumb("/segments", "Сегменты", ""),
                Breadcrumb("/segments/static", "Статические сегменты", ""),
                Breadcrumb("/segments/static/$id", "Редактирование", ""),
            )
        }
        attrs.active = props.active
        widget {
//            attrs.headerOptions = {
//                with(it) {
//                    a("/api/v1/segments/static/${id}/download") {
//                        button(type = kotlinx.html.ButtonType.button, classes = "btn btn-primary mr-2") {
//                            i("la la-cloud-download") {}
//                            +"Скачать список Email-адресов"
//                        }
//                    }
//                    button(type = kotlinx.html.ButtonType.button, classes = "btn btn-primary") {
//                        attrs.onClickFunction = {
//                            uploadKey = id
//                        }
//                        i("la la-cloud-upload") {}
//                        +"Выгрузить Email-адреса"
//                    }
//                }
//            }

            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Название:" }
                div("col-lg-9") {
                    input(InputType.text, classes = "form-control") {
                        attrs.value = name
                        attrs.onChangeFunction = {
                            name = (it.target as? HTMLInputElement)?.value.orEmpty()
                        }
                    }
                }
            }
            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Магазин:" }
                div("col-lg-9") {
                    child(dropdownSelect) {
                        attrs {
                            dropdownOpenDefault = false
                            multiSelect = false
                            showFilter = false
                            currentValue = stores.firstOrNull { it.id == store }?.let {
                                mapOf(store to it.name)
                            } ?: mapOf()
                            selectValues = stores.map { it.id to it.name }
                            onSave = {
                                store = it.keys.firstOrNull() ?: stores.firstOrNull()?.id ?: ""
                            }
                        }
                    }
                }
            }

            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Обновлен:" }
                div("col-lg-9") {
                    input(InputType.text, classes = "form-control") {
                        attrs.value = lastUpdate
                        attrs.disabled = true
                    }
                }
            }

            div("row d-flex justify-content-end mr-2 ml-2") {
                Link {
                    attrs.to = "/segments/static"
                    Button {
                        attrs.type = web.html.ButtonType.button
                        attrs.variant = "shadow"
                        attrs.className = ClassName("mr-2")
                        +"Назад"
                    }
                }
                Button {
                    attrs.type = web.html.ButtonType.button
                    attrs.variant = "primary"
                    attrs.onClick = {
                        Http.post("/segments/static/$id", StaticSegmentUpdateRequest(name, store)) { response ->
                            when (response.status) {
                                HttpStatusCode.NoContent -> {
                                    showNotification("Сохранено", NotyType.Success)
                                    segment = segment?.copy(name = name, store = store)
                                }
                                HttpStatusCode.Forbidden -> { showNotification("Недостаточно прав доступа", NotyType.Error) }
                                HttpStatusCode.BadRequest -> { showNotification("Ошибка в запросе: ${response.body<String>()}", NotyType.Error) }
                            }
                        }
                    }
                    +"Сохранить"
                }
            }

        }

        widget {
            div("row d-flex justify-content-between mr-2 ml-2 mb-2") {
                div("col-6") {
                    a("/api/v1/segments/static/${id}/download") {
                        button(type = kotlinx.html.ButtonType.button, classes = "btn btn-primary mr-2") {
                            i("la la-cloud-download") {}
                            +"Скачать список Email-адресов"
                        }
                    }
                    button(type = kotlinx.html.ButtonType.button, classes = "btn btn-primary") {
                        attrs.onClickFunction = {
                            uploadKey = id
                        }
                        i("la la-cloud-upload") {}
                        +"Выгрузить Email-адреса"
                    }
                }
                div("col-6") {
                    div("form-group") {
                        div("input-group") {
                            input(InputType.text, classes = "form-control") {
                                attrs.placeholder = "Поиск..."
                                attrs.value = searchValue
                                attrs.onChangeFunction = {
                                    searchValue = (it.target as? HTMLInputElement)?.value.orEmpty()
                                }
                            }
                            span("input-group-btn") {
                                button(type = kotlinx.html.ButtonType.button, classes = "btn btn-primary") {
                                    attrs.onClickFunction = {}
                                    i("la la-search") {}
                                }
                            }
                        }
                    }
                }
            }

            Table {
                attrs.bordered = true
                attrs.hover = true
//                thead {
//                    tr {
//                        styledTh { +"Email" }
//                        styledTh { +"Действия" }
//                    }
//                }
                tbody {
                    filtered.subList((page-1)*rows, min(page*rows, filtered.size)).chunked(3) { part ->
                        tr {
                            part.forEach { email ->
                                td {
                                    +email
                                    iconButton {
                                        attrs.icon = "la la-trash ml-2 mr-2"
                                        attrs.disabled = false
                                        attrs.type = IconButtonType.Danger
                                        attrs.onClickFunction = {
                                            Http.post("/segments/static/${id}/emails", StaticSegmentUpdateEmailsRequest(listOf(email), StaticSegmentEmailsAction.Remove)) { response ->
                                                response.checkResponseError()?.let { error ->
                                                    showNotification(error, NotyType.Error)
                                                    return@post
                                                }

                                                Http.get("/segments/static/$id/emails") { response ->
                                                    response.checkResponseError()?.let { error ->
                                                        showNotification(error, NotyType.Error)
                                                        navigate("/segments/static")
                                                        return@get
                                                    }
                                                    emails = response.body()
                                                    page = 1
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            tablePagination{
                attrs.page = page
                attrs.currentRowsPerPageValue = rows
                attrs.size = filtered.size
                attrs.handleChangePage = {
                    page = it
                }
                attrs.handleChangeRowsPerPage = {
                    val value = it.target.asDynamic().value as Int
                    rows = value
                }
            }
//            pagination {
//                attrs.page = page
//                attrs.rows = rows
//                attrs.size = filtered.size
//                attrs.onPageItemClicked = {
//                    page = it
//                }
//                attrs.rowsSizeItems = listOf(30, 60, 90, 120, 240, 480, 960)
//                attrs.onRowsSizeChange = {
//                    rows = it
//                }
//            }
        }
    }

    uploadSegmentsDialog {
        attrs.segmentId = uploadKey
        attrs.onClose = {
            uploadKey = null
            if (it) {
                Http.get("/segments/static/$id/emails") { response ->
                    response.checkResponseError()?.let { error ->
                        showNotification(error, NotyType.Error)
                        navigate("/segments/static")
                        return@get
                    }
                    emails = response.body()
                    page = 1
                }
            }
        }
    }
}
